import { render, staticRenderFns } from "./CadastrarEditarPraticasLinguagemDialog.vue?vue&type=template&id=1149b7c7"
import script from "./CadastrarEditarPraticasLinguagemDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarPraticasLinguagemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports